export const updateObject = (oldObject, updatedProperties) => ({
  ...oldObject,
  ...updatedProperties,
});

export const updateWithPrevData = (
  state,
  action,
  stateKey,
  actionKey = 'data',
  deepUpdate = false,
) => {
  let newData = action[actionKey];
  if (typeof newData === 'function') {
    newData = newData(state[stateKey]);
  }
  if (deepUpdate) {
    return updateObject(state, {[stateKey]: updateObject(state[stateKey], newData)});
  }
  return updateObject(state, {[stateKey]: newData});
};
